module.exports = __webpack_public_path__ + "static/img/49061.2f93bf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/49061.jpg
// module id = Rs7J
// module chunks = 1